












import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({})
export default class FacebookLink extends Vue {
  @Prop({
    default: 'initial'
  })
  bottom: string

  @Prop({
    default: '10px'
  })
  top: string

  @Prop({
    default: '40px'
  })
  right: string
}
